import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { ContactInfo, NotifyUser } from 'src/app/pages/pages.actions';
import { PagesState } from 'src/app/pages/pages.model';
import { callerEmail, callerFirstName, callerLastName, isPhone } from 'src/app/pages/pages.selectors';


import { WSSState } from 'src/app/wss/wss.model';
import { callerId, callId } from 'src/app/wss/wss.selectors';
import { WSSService } from 'src/app/wss/wss.service';
import { SetMIME, SetPlay } from '../training.actions';


import { TrainingState } from '../training.model';
import { gotPatients, playChanged, taskIndex } from '../training.selectors';

import { TrainingService } from '../training.service';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent {
  roll: string = "parent" //allways for the rep

  my_play: any = {};
  task_index: number = -1; //or whatever the user selcts
  scene_index: number = 0
  bShowSelTask: boolean = true


  call_id: string | undefined
  // bLoginIn: boolean = false //false  for the rep

  bSelUser: boolean = false
  bAddingUser: boolean = false
  users: any = {}
  edit_user_id: string = ""

  edit_patient: any

  caller: any = {}

  patients_keys: string[] = []

  subscriptions: any[] = []


  constructor(
    public trainingStore: Store<TrainingState>,
    public training_sevice: TrainingService,
    public pagesState: Store<PagesState>,
    private wssState: Store<WSSState>,
    private wss_service: WSSService,

  ) {
    console.log("training")

  }
  ngOnInit(): void {
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play) {

        setTimeout(() => {
          this.my_play = play
          if (this.my_play.users) {
            this.users = this.my_play.users
            this.checkThatCallerIsUser()
          } else {
            this.users = {}
            this.bShowSelTask = false
          }
        })
      }
    }))
    this.trainingStore.select(taskIndex).subscribe((task_index: number) => {
      this.task_index = task_index
      this.bShowSelTask = (this.task_index < 0)
    })

    this.subscriptions.push(this.pagesState.select(callerEmail).subscribe((email: string) => {
      this.caller.email = email
    }))
    this.pagesState.select(callerFirstName).subscribe((name: string | undefined) => {
      this.caller.first_name = name
    })
    this.pagesState.select(callerLastName).subscribe((name: string | undefined) => {
      this.caller.last_name = name
    })
    this.subscriptions.push(this.wssState.select(callerId).subscribe(async (id: string | undefined) => {
      this.caller._id = id
      this.checkThatCallerIsUser()
    }))
    this.subscriptions.push(this.trainingStore.select(gotPatients).subscribe((patients: any) => {
      if (patients) {
        this.patients_keys = Object.keys(patients)
      }
    }))

    this.subscriptions.push(this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      this.call_id = call_id
    }))
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  isSafari(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("cpu iphone os 15_0 like mac os x") > 0) {
      return false
    }
    return userAgent.includes('safari') && !userAgent.includes('chrome');
  }

  ngAfterViewInit() {
    let mime_ext = ".webm"
    let mime_type = "video/webm"
    if (this.isSafari()) {
      mime_ext = ".mp4"
      mime_type = "video/mp4"
    }
    this.trainingStore.dispatch(new SetMIME(mime_ext, mime_type))
  }

  closeSelTask() {
    this.bShowSelTask = false
  }

  //****************************************************************************
  // Users
  //****************************************************************************
  checkThatCallerIsUser() {
    if (this.caller && this.caller._id && this.my_play && this.my_play.users) {
      if (!this.my_play.users[this.caller._id]) { //The id is the one from the call and might not the same one as user_b
        let keys = Object.keys(this.my_play.users)
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i]
          let user = this.my_play.users[key]
          if (user.email == this.caller.email) {
            return
          }
        }

        this.bAddingUser = true
        this.bShowSelTask = false
      }
    }
  }
  listUser() {
    this.bSelUser = true
  }
  addUser() {
    this.edit_user_id = ""
    this.bAddingUser = true
  }
  closeSelUser() {
    this.bSelUser = false
  }
  loadUser(user_id: string) {
    this.edit_user_id = user_id
    this.bAddingUser = true
  }
  //****************************************************************************
  // Patients
  //****************************************************************************
  editPatient() {
    this.edit_patient = this.my_play
  }
  async closePatient() {
    this.edit_patient = undefined
  }
  selOtherPatient() {
    this.trainingStore.dispatch(new SetPlay({}))
  }
  publishProgress(msg: string) {
    this.pagesState.dispatch(new NotifyUser(msg))
  }
  askCallerEmail() {
    this.pagesState.dispatch(new ContactInfo("ask"))
    this.wss_service.sendMessageToOtherMembers({
      ask_for: "email"
    })
  }

}
